// extracted by mini-css-extract-plugin
module.exports = {"toc":"toc_toc___vUGa"};